import AboutPage from "../pages/AboutPage";

const About = () => {
    return (
        <AboutPage />
    )
};

export default About; 